import React from "react";
import { Box, Typography, Grid, CircularProgress } from "@mui/material";
import dayjs from "dayjs";

const TimeSlotSelector = ({
  selectedDate,
  selectedTime,
  onTimeChange,
  timeSlots,
  loading,
}) => {
  const isToday = selectedDate?.isSame(dayjs(), "day");
  const nowHour = dayjs().hour();

  return (
    <Box mt={4}>
      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
        Select Time Slot
      </Typography>

      {loading ? (
        <Box display="flex" justifyContent="center" py={3}>
          <CircularProgress />
        </Box>
      ) : !selectedDate ? (
        <Typography variant="body2" color="text.secondary">
          Select a day to see the available slots
        </Typography>
      ) : timeSlots.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No available time slots for this day.
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {timeSlots.map((slot) => {
            const isSelected = selectedTime === slot.time;
            const isDisabled = slot.remaining <= 0;
            const slotHour = parseInt(slot.time.split(":")[0]);
            const pastToday = isToday && slotHour <= nowHour;
            const disabled = isDisabled || pastToday;

            let availabilityLabel = "";
            if (slot.remaining <= 0) availabilityLabel = "Fully booked";
            else if (slot.remaining === 1) availabilityLabel = "Only 1 left";
            else if (slot.remaining <= 2)
              availabilityLabel = `${slot.remaining} left`;
            else availabilityLabel = "Available";

            return (
              <Grid item key={slot.time}>
                <Box
                  sx={{
                    border: "2px solid",
                    borderColor: isSelected ? "#FD7762" : "#ccc",
                    borderRadius: 2,
                    backgroundColor: disabled ? "#f3f3f3" : "white",
                    color: disabled ? "text.disabled" : "text.primary",
                    opacity: disabled ? 0.6 : 1,
                    minWidth: 120,
                    px: 2,
                    py: 1.5,
                    cursor: disabled ? "not-allowed" : "pointer",
                    textAlign: "center",
                    boxShadow: isSelected
                      ? "0 0 0 2px rgba(253,119,98,0.2)"
                      : "0 1px 2px rgba(0,0,0,0.05)",
                    transition: "all 0.2s ease",
                    "&:hover": {
                      boxShadow:
                        !disabled && !isSelected
                          ? "0 0 0 2px rgba(0,0,0,0.1)"
                          : undefined,
                    },
                  }}
                  onClick={() => !disabled && onTimeChange(slot.time)}>
                  <Typography fontWeight="bold" fontSize="0.95rem">
                    {slot.time}
                  </Typography>

                  <Typography
                    variant="caption"
                    fontWeight={slot.remaining <= 2 ? "bold" : "regular"}
                    color={
                      slot.remaining <= 0
                        ? "error.main"
                        : slot.remaining <= 2
                        ? "warning.main"
                        : "text.secondary"
                    }>
                    {availabilityLabel}
                  </Typography>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      )}
    </Box>
  );
};

export default TimeSlotSelector;
